import SmartStorage from './storage/index'
import SmartHttp from './http/index'
import SmartRem from './rem/index.js'
import SmartFilter from './filter'
import { Message } from 'element-ui';

let messageInstance = null;

const showMessage=(message)=>{
    if (messageInstance) {
        // 如果已经存在一个消息提示实例，则先关闭它
        Message.closeAll();
      }
      
      // 显示新的消息提示，并保存该实例
      messageInstance = Message({
        message: message,
        type: 'warning',
        onClose: () => {
          messageInstance = null; // 当消息提示关闭时，将实例置为null
        }
      });
}
const formErrorScroll =()=>{
    if (document.querySelector('.el-form-item__error')) {
        document
        .querySelector('.el-form-item__error')
        .parentNode.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
        })
        }
}
export {
    SmartStorage,
    SmartHttp,
    SmartRem,
    SmartFilter,
    formErrorScroll,
    showMessage
}